module.exports = __webpack_public_path__ + "static/img/cont40_05.4c2e479.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont40_05.jpg
// module id = qMjI
// module chunks = 0